/* eslint-disable */
// @ts-nocheck
import { ghb } from "@cervval.js/i18n/src/i18n.tools";

export const i18n = {
    ariaLabel: "Cliquer pour changer d'image",
    cancelBtn: "Annuler",
    pickerTitle: {
        innerHTML: "Importer une image"
    },
    sizeRecommandation: {
        innerHTML: "Préférez une image de 800*400px"
    }
};